import { Link } from 'react-router-dom';
import { SOCIAL_LINKS } from '@/constants/socialLinks';

export default function Footer() {
  return (
    <footer className="bg-text-50 border-t border-text-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* サービス情報 */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img src="/images/logo_03_wide_transparent.png" alt="企画苔" className="h-8" />
            </div>
            <p className="text-text-600 text-sm mb-2">
              AIがあなたにぴったりの集まりを企画。
              <br />
              家族や友達との時間をもっと楽しく、もっと簡単に。
            </p>

            {/* 公式SNS（アイコンのみのリンク。タッチ領域はHIG推奨の44px確保） */}
            <nav aria-label="公式SNS">
              <ul className="flex items-center -ml-3">
                {SOCIAL_LINKS.map(({ name, url, label, Icon }) => (
                  <li key={name}>
                    <a
                      href={url}
                      target="_blank"
                      rel="me noopener noreferrer"
                      aria-label={label}
                      title={label}
                      className="flex h-11 w-11 items-center justify-center rounded-full text-text-500 hover:text-primary-600 hover:bg-text-100 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
                    >
                      <Icon className="h-5 w-5" />
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {/* サービス */}
          <div>
            <h3 className="font-semibold text-text-900 mb-4">サービス</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/features"
                  className="text-text-600 hover:text-primary-600 text-sm transition-colors"
                >
                  機能紹介
                </Link>
              </li>
              <li>
                <Link
                  to="/pricing"
                  className="text-text-600 hover:text-primary-600 text-sm transition-colors"
                >
                  料金プラン
                </Link>
              </li>
              <li>
                <Link
                  to="/tools"
                  className="text-text-600 hover:text-primary-600 text-sm transition-colors"
                >
                  便利ツール
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-text-600 hover:text-primary-600 text-sm transition-colors"
                >
                  ブログ
                </Link>
              </li>
              <li>
                <Link
                  to="/changelog"
                  className="text-text-600 hover:text-primary-600 text-sm transition-colors"
                >
                  更新履歴
                </Link>
              </li>
            </ul>
          </div>

          {/* 法的情報 */}
          <div>
            <h3 className="font-semibold text-text-900 mb-4">法的情報</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/terms"
                  className="text-text-600 hover:text-primary-600 text-sm transition-colors"
                >
                  利用規約
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-text-600 hover:text-primary-600 text-sm transition-colors"
                >
                  プライバシーポリシー
                </Link>
              </li>
              <li>
                <Link
                  to="/tokushoho"
                  className="text-text-600 hover:text-primary-600 text-sm transition-colors"
                >
                  特定商取引法に基づく表記
                </Link>
              </li>
              <li>
                <Link
                  to="/data-sources"
                  className="text-text-600 hover:text-primary-600 text-sm transition-colors"
                >
                  データ出典・ライセンス
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-text-600 hover:text-primary-600 text-sm transition-colors"
                >
                  お問い合わせ
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* コピーライト */}
        <div className="mt-8 pt-8 border-t border-text-200">
          <p className="text-center text-text-500 text-sm">
            © 2025-{new Date().getFullYear()} 企画苔. All rights reserved.
          </p>
          <p className="text-center text-text-400 text-xs mt-2">
            「LINE」および「LINEロゴ」は、LINEヤフー株式会社の商標または登録商標です。
          </p>
        </div>
      </div>
    </footer>
  );
}
